import Tool, { type IToolActionInput } from './Tool';
import Shortcut from '../utils/Shortcut';

class ToolExportSVG extends Tool {
  static toolName = 'Export to SVG';
  static shortcut = new Shortcut('Cmd+E');

  static action({ controller }: IToolActionInput) {
    const canvas = controller.canvas;

    // Zoom all into view before taking snapshot.
    const originalTransform = canvas.viewportTransform;
    controller.actionZoomIntoView();

    const svg = canvas.renderToSVG();

    // Create a fake link to trigger the download.
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.target = '_blank';
    const blob = new Blob([svg], { type: 'octet/stream' });
    const url = URL.createObjectURL(blob);
    a.href = url;
    a.download = `${controller.exportFileName}.svg`;
    a.click();
    a.remove();
    URL.revokeObjectURL(url);

    canvas.viewportTransform = originalTransform;
  }

  static enabled() {
    return true;
  }
}

export default ToolExportSVG;
